import { render, staticRenderFns } from "./BreadcrumbsObserver.vue?vue&type=template&id=15ab1abc&scoped=true"
import script from "./BreadcrumbsObserver.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsObserver.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbsObserver.vue?vue&type=style&index=0&id=15ab1abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ab1abc",
  null
  
)

export default component.exports